import React from 'react';

import { ReactFCV } from '@types';

import { StyledProductListSkeletonWrapper } from './styled';
import { UpsellingProductRowSkeleton } from './UpsellingProductRowSkeleton';

export const UpsellingProductListSkeleton: ReactFCV = () => (
  <StyledProductListSkeletonWrapper data-testid="upselling-product-list-skeleton">
    <UpsellingProductRowSkeleton />
    <UpsellingProductRowSkeleton />
    <UpsellingProductRowSkeleton />
    <UpsellingProductRowSkeleton />
  </StyledProductListSkeletonWrapper>
);
